import React, {Fragment, useEffect, useState} from 'react'
import {Form, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useFormik} from 'formik'
import {configuracionFormAction19, obtenerDatosCierreGestion, obtenerMaxNroCuotas, postActualizarCierre} from '../../../../store/actions/cierre-gestion-action'
import CierreGestion from './cierreGestion'
import DeclaracionPagoRecobro from './declaracionPagoRecobro'
import { validationSchemas } from '../../../../common/validation-Schemas-cierre-gestion-recupero'
import Acciones from './acciones'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { isValidParam } from '../../../../common/Formatos'

const CierreGestionModal = ({showCierre, handleCloseCierre}) => {
    const [loading, setLoading]=useState(false)  
    const [tieneRecupero, setTieneRecupero] = React.useState(1)
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const {llaves} = data_recepciona
    const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
    const {montosInformados} = data_modal_cia
    const data_cierre_modal = useSelector((state) => state.cierreGestionReducer)
    const {maxNroCuotas, respuestaModalCierre} = data_cierre_modal
    const [isRegistraHito, setIsRegistraHito]=useState(false)
    const [showToast, setShowToast] = useState(false);
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 
    const dispatch = useDispatch()
    const [pagoTotal, setPagoTotal] = React.useState('')
    const [pagoCuotas, setPagoCuotas] = React.useState('')
    const [calcMode, setCalcMode] = React.useState('')
    const [calendarDirty, setCalendarDirty] = React.useState(false)
    const {rutOrganizacion} = Auth.currentUser()
    const data_gestion = useSelector((state) => state.procesoExtrajudicialReducer)
    const {datosGestionImplicado} = data_gestion

    const [medioPagoPie, setMedioPagoPie] = React.useState('')
    const [montoRecobro, setMontoRecobro ]=useState('')
    const [montoPagoPieNoFormato, setMontoPagoPieNoFormato] = useState('')
    const [montoRendirPieNoFormato, setMontoRendirPieNoFormato] = useState('')
    
    const [cuotasCalculadas, setCuotasCalculadas] = useState('')

    //console.log("tieneHitoCartaCia: ", datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['tieneHitoCartaCia']);

    useEffect(() => {
        if (llaves) {

            let query = Buffer.from(JSON.stringify({
                "idImplicado": llaves && llaves['idImplicado'],
                "idCaso": llaves && llaves['idCaso']
            })).toString('base64')
            dispatch(obtenerDatosCierreGestion(query))
        }
    }, [dispatch, llaves, showCierre])
    useEffect(() => {
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 19
        })).toString('base64')
        dispatch(configuracionFormAction19(query))
    }, [dispatch])

    useEffect(() => {
        if (pagoCuotas) {
            let query = Buffer.from(
                JSON.stringify({ rutcia: llaves && llaves['idOrgCaso'], parametro: 31 })
            ).toString('base64')
            dispatch(obtenerMaxNroCuotas(query))
        }
    }, [dispatch, pagoCuotas])
    
    useEffect(()=>{ 
        setMontoRecobro(montosInformados && montosInformados.montosInformados[0]['MontoRecobro']);
     },[montosInformados])

    useEffect(()=>{
        if (respuestaModalCierre && respuestaModalCierre?.respuestaModalCierre["code"] === 1) {
            formik.setFieldTouched('file', false);
            formik.setFieldTouched('fileComprobante', false);
            formik.errors.file='';
            formik.errors.fileComprobante='';
        }
    },[respuestaModalCierre])

    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "codHito": "",
            "fechaHito": "",
            "minutaHito": "",
            "cierreConRecupero": "",
            "idUsuario": "",
            "nroChequeTrx":"",
            "nroChequeTrx":"",
            "nroChequeTrx":"",
            "fechaTransaccion":"",
            "covenioPagoCuota":"",
            "cntCuotas":"",
            "diaPago":"",
            "fechaPrimerPago":"",
            "fechaUltimoPago":"",
            "monedaRendicion":"",
            "montoRendicion":""
        },
        validationSchema: validationSchemas(isRegistraHito, pagoTotal, pagoCuotas, maxNroCuotas && parseInt(maxNroCuotas['valorParametro']), medioPagoPie, montoRecobro),
        onSubmit: (formData) => {
            
            const dataForm = {
                ...formData
            }
            if (pagoCuotas && montoPagoPieNoFormato != montoRendirPieNoFormato) {
                formik.setErrors({ montoRendirPie: `Valor debe ser igual a ${dataForm['montoPagoPie'] }` });
                return;
            }

            if (pagoCuotas && cuotasCalculadas && cuotasCalculadas.length > 0) {
                if (calendarDirty) {
                    return;
                }
                const montoRecobroCuotas = (montosInformados?.montosInformados[0]['MontoRecobro'] || 0) - (montoPagoPieNoFormato || 0);
                const sumaCuotas = cuotasCalculadas.reduce((acc, c) => acc + parseInt(c.montoCuota || 0), 0);
                if (sumaCuotas !== parseInt(montoRecobroCuotas)) {
                    alert(`La suma de cuotas (${sumaCuotas.toLocaleString('es-CL')}) debe ser igual al monto Recobro Cuotas (${parseInt(montoRecobroCuotas).toLocaleString('es-CL')}).`);
                    return;
                }
            }

            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] = llaves && llaves['idUsuario']
            dataForm['cierreConRecupero'] = tieneRecupero
            dataForm['cierreConPagoTotal'] = pagoTotal
            dataForm['cierreConPagoCuotas'] = pagoCuotas
            dataForm['monedaRendicion'] = montosInformados && isValidParam(montosInformados.montosInformados[0]['CodMoneda']) ? montosInformados.montosInformados[0]['CodMoneda'] : ''
            dataForm['montoRendicion'] = montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobro']) ? montosInformados.montosInformados[0]['MontoRecobro'] : ''
            dataForm['montoCosto'] = montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoCosto']) ? montosInformados.montosInformados[0]['MontoCosto'] : ''
            dataForm['porConvenido'] = montosInformados && isValidParam(montosInformados.montosInformados[0]['PorConvenido']) ? montosInformados.montosInformados[0]['PorConvenido'] : ''
            dataForm['tieneHitoCartaCia'] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['tieneHitoCartaCia'] !== undefined && datosGestionImplicado.datosGestionImplicado[0]['tieneHitoCartaCia'] !== null && datosGestionImplicado.datosGestionImplicado[0]['tieneHitoCartaCia'] !== '' ? datosGestionImplicado.datosGestionImplicado[0]['tieneHitoCartaCia'] : ''
            dataForm['montoPagoPie'] = montoPagoPieNoFormato;
            dataForm['cuotasCalculadas'] = cuotasCalculadas;
            dataForm['calcMode'] = calcMode;

            dataForm['montoRendirPie'] = montoRendirPieNoFormato;

            setLoading(true);            
            
            const processFile = (file) => {
                return new Promise((resolve, reject) => {
                    if (!file) {
                        resolve(null);
                        return;
                    }
            
                    getBase64(file)
                        .then((base64data) => {
                            resolve({
                                filename: file.name,
                                mimetype: file.type,
                                base64data: base64data.split(',')[1], // Extrae solo el contenido base64
                            });
                        })
                    .catch((error) => reject(error));
                });
            };
            
            Promise.all([processFile(formData.file), processFile(formData.fileComprobante)])
                .then(([fileData, fileComprobanteData]) => {
                    let data = { ...dataForm };
            
                    if (fileData) {
                        data.file = fileData;
                    }
                    if (fileComprobanteData) {
                        data.fileComprobante = fileComprobanteData;
                    }

                    console.log("data: ", data);
            
                    dispatch(postActualizarCierre(data))
                        .then(() => {
                            handleShowToast();
                            setLoading(false);
                        })
                        .then(() => {
                            //delete formData.file;
                            //delete formData.fileComprobante;
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.error(error.message);
                            alert(error.message);
                        });
            })
            .catch((error) => {
                setLoading(false);
                console.error("Error procesando archivos:", error);
                alert("Hubo un error procesando los archivos.");
            });

        }
    })
    /*const UpdateUltimoHito=()=>{
        if (llaves) {
    
          let query = Buffer.from(
            JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
          ).toString('base64')
          dispatch(obtenerDatosGestionImplicado(query))
        }
    }*/
    return (
        <>
            <LoadingComponent show={loading}/>
            <Modal show={showCierre}
                onHide={handleCloseCierre}
                size='xl'>
                <Form onSubmit={formik.handleSubmit}>
                    <CierreGestion formik={formik} 
                        tieneRecupero={tieneRecupero}
                        setTieneRecupero={setTieneRecupero} 
                        handleCloseCierre={handleCloseCierre}
                        setIsRegistraHito={setIsRegistraHito}   
                        showToast={showToast}
                        setShowToast={setShowToast}
                        setPagoTotal={setPagoTotal}         
                        setPagoCuotas={setPagoCuotas} 
                    />
                    {tieneRecupero ? (                    
                    (<DeclaracionPagoRecobro formik={formik}
                        setPagoTotal={setPagoTotal}
                        setPagoCuotas={setPagoCuotas}
                        medioPagoPie={medioPagoPie}
                        setMedioPagoPie={setMedioPagoPie}
                        montoPagoPieNoFormato={montoPagoPieNoFormato}
                        setMontoPagoPieNoFormato={setMontoPagoPieNoFormato}
                        setCuotasCalculadas={setCuotasCalculadas}
                        montoRendirPieNoFormato={montoRendirPieNoFormato}
                        setMontoRendirPieNoFormato={setMontoRendirPieNoFormato}
                        calcMode={calcMode}
                        setCalcMode={setCalcMode}
                        setCalendarDirty={setCalendarDirty}
                        calendarDirty={calendarDirty}
                    />)
                    ):('')}
                    <Acciones handleCloseCierre={handleCloseCierre}/>
                </Form>
            </Modal>
        </>
    )
}

export default CierreGestionModal
const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
  };